export default __webpack_public_path__ + "static/media/USA-2.aa5dc670.jpg";